import {Provider} from '@oilstone/container';
import LocalStorage from "@/services/local-storage";

export default new Provider().register(container => {
    container.singleton('localStorage', () => LocalStorage.make());
});
